export const setLanguage = (lang) => {
    document.querySelectorAll("[data-i18n]").forEach((el) => {
      const key = el.getAttribute("data-i18n");
      el.textContent = translations[lang][key] || el.textContent;
    });
  };

export const t = (lang, key) => translations[lang]?.[key] ?? key;

const translations = {
    lt: {
      add_order_title: "Pridėti kebabo užsakymą",
      name_label: "Vardas:",
      name_placeholder: "Tavo vardas",
      size_label: "Dydis:",
      type_label: "Todzes / Paprastas:",
      sauce_label: "Padazas:",
      size_mazas: "Mazas",
      size_didelis: "Didelis",
      type_todzes: "Todzes",
      type_paprastas: "Paprastas",
      sauce_pikantiskas: "Pikantiskas",
      sauce_cesnakinis: "Cesnakinis",
      sauce_astrus: "Astrus",
      sauce_mixas: "Mixas",
      submit_btn: "Pridėti užsakymą",
      current_orders: "Dabartiniai užsakymai",
      delete_btn: "Ištrinti",
      contacts_header: "Kontaktai kebabinėms",
      beer_rain_btn: "Lietus 🍺",
      reset_btn: "Išvalyti visus užsakymus",
      randomize_btn: "🎲",
      randomize_title: "Atsitiktinis kebabas",
      login_title: "Prisijungti",
      login_subtitle: "Įvesk vardą ir slaptažodį",
      login_password_label: "Slaptažodis:",
      login_password_placeholder: "Slaptažodis",
      login_btn: "Prisijungti",
      login_error: "Neteisingas slaptažodis",
      login_name_required: "Įvesk vardą",
      logout_btn: "Atsijungti",
    },
    en: {
      add_order_title: "Add Kebab Order",
      name_label: "Name:",
      name_placeholder: "Your name",
      size_label: "Size:",
      type_label: "Type:",
      sauce_label: "Sauce:",
      size_mazas: "Small",
      size_didelis: "Large",
      type_todzes: "Todzes",
      type_paprastas: "Regular",
      sauce_pikantiskas: "Mild",
      sauce_cesnakinis: "Garlic",
      sauce_astrus: "Spicy",
      sauce_mixas: "Mix",
      submit_btn: "Submit Order",
      current_orders: "Current Orders",
      delete_btn: "Delete",
      contacts_header: "Kebab Contacts",
      beer_rain_btn: "Rain 🍺",
      reset_btn: "Clear all orders",
      randomize_btn: "🎲",
      randomize_title: "Random kebab",
      login_title: "Log in",
      login_subtitle: "Enter your name and password",
      login_password_label: "Password:",
      login_password_placeholder: "Password",
      login_btn: "Log in",
      login_error: "Wrong password",
      login_name_required: "Enter your name",
      logout_btn: "Log out",
    },
  };
  